import { useEffect, useState } from 'react';
import { Spinner } from '@nextui-org/react';

const MESSAGE_ROTATE_MS = 60_000;

const CLAIM_SUBMIT_PROGRESS_MESSAGES = [
  'Sending your claim for processing…',
  'You can sit back — we’re taking care of the submission.',
  'Still working on it; thanks for your patience.',
  'Almost there — just finishing the last steps.',
  'Hang tight — this usually wraps up in a moment.',
] as const;

type ClaimSubmitProgressOverlayProps = Readonly<{
  isActive: boolean;
}>;

export function ClaimSubmitProgressOverlay({ isActive }: ClaimSubmitProgressOverlayProps) {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    if (!isActive) {
      setMessageIndex(0);
      return;
    }
    const intervalId = globalThis.setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % CLAIM_SUBMIT_PROGRESS_MESSAGES.length);
    }, MESSAGE_ROTATE_MS);
    return () => globalThis.clearInterval(intervalId);
  }, [isActive]);

  if (!isActive) return null;

  const message = CLAIM_SUBMIT_PROGRESS_MESSAGES[messageIndex];

  return (
    <div
      className="fixed inset-0 z-[10050] flex items-center justify-center bg-black/45 backdrop-blur-sm"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="claim-submit-progress-title"
      aria-busy="true"
    >
      <div className="mx-4 w-full max-w-md rounded-xl border border-default-200 bg-content1 p-8 shadow-xl flex flex-col items-center gap-5 text-center">
        <Spinner size="lg" color="primary" aria-hidden />
        <div id="claim-submit-progress-title">
          <p className="text-base font-semibold text-foreground">Submitting your claim</p>
          <p className="text-sm text-default-500 mt-2" aria-live="polite">
            {message}
          </p>
        </div>
      </div>
    </div>
  );
}
